
import ForumPostDetail from '../../components/ForumPostDetail';

export default function NewsDetailPage() {
  return <ForumPostDetail categoryId="news" />;
}
